<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
                <user-permissions-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import UserPermissionsCrud from './UserPermissionsCrud'
export default {
    name: 'UserPermissionsPage',
    components: { UserPermissionsCrud }
}
</script>
